<template>
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 6.75C3 6.33579 3.33579 6 3.75 6H20.25C20.6642 6 21 6.33579 21 6.75C21 7.16421 20.6642 7.5 20.25 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75ZM12 12C12 11.5858 12.3358 11.25 12.75 11.25H20.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H12.75C12.3358 12.75 12 12.4142 12 12ZM3 17.25C3 16.8358 3.33579 16.5 3.75 16.5H20.25C20.6642 16.5 21 16.8358 21 17.25C21 17.6642 20.6642 18 20.25 18H3.75C3.33579 18 3 17.6642 3 17.25Z"
    />
    <path
      d="M6.01928 8.20911C6.25155 7.97684 6.62813 7.97684 6.8604 8.20911L10.2307 11.5794C10.3423 11.691 10.4049 11.8423 10.4049 12C10.4049 12.1577 10.3423 12.309 10.2307 12.4206L6.8604 15.7909C6.62813 16.0232 6.25155 16.0232 6.01928 15.7909C5.78701 15.5586 5.78701 15.182 6.01928 14.9498L8.96904 12L6.01928 9.05024C5.78701 8.81797 5.78701 8.44138 6.01928 8.20911Z"
    />
  </svg>
</template>
